export const Editor = () => {
    return (
      <div>
        <p>あなたは編集者です</p>
        <h1>編集者専用メニュー</h1>
        <p>*********</p>
        
      </div>
    );
  };
  